import { EVENT_NAME as USER_PREFS_EVENT } from '@adobe-fonts/site/events/UserPrefsEvent.js';
import { getService as service } from '../../util/angular_helpers.js';

export function registerEventHandlers(element) {
  element.addEventListener(USER_PREFS_EVENT, handleUserPrefsEvent);
}

export async function handleUserPrefsEvent(event) {
  const UserPrefsService = service('UserPrefsService');
  await UserPrefsService.updatePrefs(event.detail);
}
